import React from 'react';
import classnames from 'classnames';

import InvisibleButton from './InvisibleButton';
import volume_on from './assets/SOUNDon.png';
import volume_off from './assets/SOUNDoff.png';
import './MuteButton.css';

const MuteButton = ({currently_muted, focus_ref=null, has_focus=false, on_select=null}) => {
	const button = <InvisibleButton
		focus_ref={focus_ref}
		has_focus={has_focus}
		on_select={on_select}
		width={185}
		height={150}
		right={0}
		top={0}
	/>;

	return <div className="MuteButton">
		<img src={currently_muted ? volume_off : volume_on} alt="" />
		{button}
	</div>
}

export default MuteButton;


// WEBPACK FOOTER //
// ./src/MuteButton.js